module.exports = __webpack_public_path__ + "img/logo.2c9d5178.svg";